import * as React from 'react';
import Layout from '../../components/Layout';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import ValuableContentLanding from '../../components/ValuableContentLanding';
import { getVideoSrc } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import IntroCreatePlaybooksDragAndDrop from '../../components/IntroCreatePlaybooksDragAndDrop';
import PlaybookFeatures from '../../components/PlaybookFeatures';
import InstallApp from '../../components/InstallApp';
import OpinionsFromUsers from '../../components/OpinionsFromUsers';

export default function FiveDrillsManychatPage() {
    const { t, i18n } = useTranslation();

    const drills = [
        //2on2 ball screen defense
        {
            id: 1,
            title: t('FiveDrillsManychatPage02'),
            description: t('FiveDrillsManychatPage03'),
            image: '/images/drill-1-2on2-ball-screen-def.png',
            videoUrl: getVideoSrc('drill-1-2on2-ball-screen-def', i18n.language)
        },
        //1on1 level the ball
        {
            id: 2,
            title: t('FiveDrillsManychatPage04'),
            description: t('FiveDrillsManychatPage05'),
            image: '/images/drill-2-level-ball.png',
            videoUrl: getVideoSrc('drill-2-level-ball', i18n.language)
        },
        //3on3 stop cuts
        {
            id: 3,
            title: t('FiveDrillsManychatPage06'),
            description: t('FiveDrillsManychatPage07'),
            image: '/images/drill-3-stop-cuts.png',
            videoUrl: getVideoSrc('drill-3-stop-cuts', i18n.language)
        },
        //1on1 defensive recovery
        {
            id: 4,
            title: t('FiveDrillsManychatPage08'),
            description: t('FiveDrillsManychatPage09'),
            image: '/images/drill-4-recuperacion-defensiva.png',
            videoUrl: getVideoSrc('drill-4-recuperacion-defensiva', i18n.language)
        },
        //2on2 gaps and stunts
        {
            id: 5,
            title: t('FiveDrillsManychatPage10'),
            description: t('FiveDrillsManychatPage11'),
            image: '/images/drill-5-2on2-gaps-and-stunts.png',
            videoUrl: getVideoSrc('drill-5-2on2-gaps-and-stunts', i18n.language)
        },
    ];

    return (
        <>
            <Layout>
                <Header />
                <ValuableContentLanding
                    drills={drills}
                    title={t('FiveDrillsManychatPage00')}
                    buttonText={t('FiveDrillsManychatPage01')}
                />
                <IntroCreatePlaybooksDragAndDrop />
                <PlaybookFeatures />
                <InstallApp />
                <OpinionsFromUsers />
                <Footer />
                <LanguageSwitcher />
            </Layout>
        </>
    );
}
